import "./DocOnlineFooter.scss";
import { useTranslation } from "react-i18next";
import CompanyLogo from "../../components/CompanyLogo/CompanyLogo";
import {
  comapanyNameToClass
} from "../../common/helper";

const DocOnlineFooter = ({ candidacyCompany, privacyPolicy }) => {
  const { t } = useTranslation();

  function beeColorText() {
    if(candidacyCompany === "Bee" || candidacyCompany === "AGAP2IND"){
      return "bee-color-text";
    }else {
      return "";
    }
  };

  return (
    <div
      className={`footer-container ${comapanyNameToClass(candidacyCompany)}`}
    >
      <div className="footer-top">
        <a
          href={privacyPolicy}
          target="_blank"
          rel="noopener noreferrer"
          className={`${beeColorText(candidacyCompany)}`}
        >
          {t("Politica de Privacidade")}
        </a>
        <CompanyLogo
          company={candidacyCompany}
          height="30px"
          width="auto"
          alt="logo"
        />
      </div>
    </div>
  );
};

export default DocOnlineFooter;
